import { Col, message, Row, TimePicker, Card, Switch, Divider } from "antd";
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { postRequest } from "../../services/mainApp.service";
import Title from "antd/lib/typography/Title";
import FormButton from "../../components/general/FormButton";
import { SaveOutlined, LoadingOutlined, BellOutlined, SearchOutlined } from "@ant-design/icons";


const CompanySettings = () => {
  const [posSetting, setPosSetting] = useState({});
  const [loading, setLoading] = useState(false);
  const userData = useSelector((state) => state.authReducer);
  const [data, setData] = useState([]);

  useEffect(() => {
    const controller = new AbortController();
    let isMounted = true; // <-- track mount status

    const fetch = async () => {
      setLoading(true);
      try {
        const response = await postRequest(
          "/PosSetting",
          {
            OperationId: 1,
            CompanyId: userData.CompanyId,
            UserId: userData.UserId,
            UserIP: userData.UserIP,
          }
        );

        if (isMounted) {

          setPosSetting(response?.data?.DataSet || {});

          setData(response?.data?.DataSet?.Table1 || []);
        }
      } catch (error) {
        if (error.name !== "AbortError") {
          console.error("Failed to load ", error);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetch();

    return () => {
      controller.abort();
      isMounted = false; // <-- prevent state update
    };
  }, []);

  const onChange = (checked, child) => {
    const updated = data.map((item) =>
      item.SetupDetailId === child.SetupDetailId ? { ...item, SettingValue: checked } : item
    );
    setData(updated);
  };

  const onSave = async () => {
    setLoading(true);

    try {
      const payload = {
        OperationId: 2,
        CompanyId: userData.CompanyId,
        UserId: userData.UserId,
        UserIP: userData.UserIP,
        PosSettingDetailList: data
          .filter(a => a.SettingValue === true)
          .map((b) => ({
            SetupDetailId: b.SetupDetailId,
            SettingValue: b.SettingValue === 1 || b.SettingValue === true ? 'true' : 'false'
          })),
      };

      const updatedPosSetting = await postRequest("/PosSetting", payload)
        .then((response) => {

          if (response?.error === true) {
            message.error(response?.errorMessage);
            return;
          }
          if (response?.data?.response === false) {
            message.error(response?.DataSet?.Table?.errorMessage);
            return;
          }
          message.success(response.successMessage);

          fetch();
        });

      // .then((response) => {
      //           if (response?.error === true) {
      //             dispatch({
      //               type: TOGGLE_TABLE_LOADING,
      //             });
      //             message.error(response?.errorMessage);
      //             return;
      //           }
      //           if (response?.data?.response === false) {
      //             message.error(response?.DataSet?.Table?.errorMessage);
      //             return;
      //           }

      //           dispatch({
      //             type: SET_TABLE_DATA,
      //             payload: {
      //               table: response?.data?.DataSet?.Table,
      //             },
      //           });
      //           delete response.data.DataSet.Table;
      //           dispatch({
      //             type: SET_SUPPORTING_TABLE,
      //             payload: response?.data?.DataSet,
      //           });
      //         })

    } catch (error) {
      console.error("Toggle failed", error);
    } finally {
      setLoading(false);
    }


  };

  return (
    <>
      <div style={{ margin: 5 }}>
        <Row>
          <Col span={20}>
            <Title level={3} style={{ color: "#017971" }}>
              Pos Settings
            </Title>
          </Col>
          <Col span={4} style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}>
            <FormButton
              title="Save"
              type="primary"
              onClick={() => {
                onSave();
              }}
              icon={loading ? <LoadingOutlined /> : <SaveOutlined />}
            />
          </Col>
        </Row>
        <div
          style={{
            background: "white",
            padding: 15,
            boxShadow: "0 0 5px lightgray",
            borderRadius: 2,
          }}
        >

          <div style={{ display: "flex", justifyContent: "left" }}>
            <Row gutter={[16, 2]} style={{ width: "100%" }}>

              {posSetting?.Table?.length > 0 &&
                posSetting?.Table?.map((record) => (
                  <>
                    <Col span={6}>
                      <Card type="inner" title={<span style={{ fontWeight: "bold" }}>{record.SetupDetailName}</span>} >
                        {posSetting?.Table1?.length > 0 &&
                          posSetting?.Table1
                            .filter(a => a.ParentName === record.SetupDetailName)
                            .map((child) => (
                              <>
                                <Row>
                                  <Col span={16}>
                                    <p className="m-0">{child.SetupDetailName}</p>
                                  </Col>
                                  <Col span={8}>
                                    <Switch
                                      id={child.SetupDetailId}
                                      className="bg-gray-200"
                                      // checked={child.SettingValue}
                                      checked={data.find(a => a.SetupDetailId === child.SetupDetailId)?.SettingValue ?? false}
                                      onChange={(checked) => onChange(checked, child)}
                                      style={{
                                        backgroundColor: data.find(a => a.SetupDetailId === child.SetupDetailId)?.SettingValue === true
                                          ? "rgb(1, 121, 113)" : "grey",
                                      }}
                                    />

                                  </Col>
                                  <Divider></Divider>
                                </Row>
                              </>
                            ))}
                      </Card>
                    </Col>
                  </>

                ))}

            </Row>
          </div>

        </div>
      </div>


    </>
  );
};

export default CompanySettings;
